import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import { useSelector } from "react-redux";

import { useParams } from "react-router-dom";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";
import useSnackbar from "../../../hooks/useSnackbar";
import useErrorHandler from "../../../hooks/useErrorHandler";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import { revRecognitionPlanTable } from "../../../config/grid-column-defs";
import { getTransactionRevArrangRevenueRecognitionPlan } from "../../../api/transaction-type";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle variant="h2" sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function RevenueRecognitionPlanViewDialog({
  open,
  itemId,
  handleClose,
}) {
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [dialogTabIndex, setDialogTabIndex] = useState(0);
  useEffect(() => {
    console.log("item id---", itemId);
  }, [itemId]);
  async function getTransactionRevenueRecognitionPlanValueData(limit, offset) {
    try {
      const { data } = await getTransactionRevArrangRevenueRecognitionPlan(
        user.token,
        {
          id: params.docNo,
          item_id: itemId,
          limit,
          offset,
        }
      );

      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      // console.log(error);
      // snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }

  return (
    <div className="dialogWidth">
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        className="dialog-box"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => {
            handleClose();
          }}
          className="closeBtn"
        >
          Revenue Recognition Plan
        </BootstrapDialogTitle>
        <DialogContent dividers>
          {/* body content */}
          {/* <Box className="viewDetilsBox">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4} className="m-b-10">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Revenue Plan Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="Revenue Plan Type"
                  >
                    <MenuItem value="all">All</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box> */}

          <Box className="viewDetilsBox">
            <AgGridPaginatedTable
              getTableRows={getTransactionRevenueRecognitionPlanValueData}
              columns={revRecognitionPlanTable}
              perPage={2}
              refreshCounter={0}
            />
          </Box>

          {/* body content */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
            }}
            className="backBtn"
          >
            Cancel
          </Button>
          {/* <Button onClick={() => {}} className="backBtn">
            Edit
          </Button> */}
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
